(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!window.customElements || customElements.get('mjl-product-hero')) return;

  class MJLProductHero extends HTMLElement {
    connectedCallback() {
      // The editor may insert the same section again; each connection owns its listeners.
      queueMicrotask(() => { if (this.isConnected && !this.lifecycle) this.start(); });
    }

    disconnectedCallback() {
      if (!this.lifecycle) return;
      this.lifecycle.abort();
      this.lifecycle = null;
      this.stopAll();
      this.observer?.disconnect();
      this.sizeObserver?.disconnect();
    }

    start() {
      this.grid = this.querySelector('.mjl-rg__grid');
      if (!this.grid) return;
      this.lifecycle = new AbortController();
      const signal = this.lifecycle.signal;
      this.pool = [...this.querySelectorAll('template[data-mjl-product]')].map(template => ({
        id: template.dataset.slotId, block: template.dataset.blockId, template
      }));
      this.byId = new Map(this.pool.map(item => [item.id, item]));
      this.states = [];
      this.reserved = new Set();
      this.seen = new Set();
      this.failed = new Map();
      this.running = false;
      this.inView = true;
      this.userPaused = false;
      this.explicitPlay = false;
      this.editorSelected = false;
      this.editor = this.dataset.editor === 'true' || !!window.Shopify?.designMode;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.auto = this.dataset.rotate === 'true';
      this.dwell = this.number('dwell', 5000, 2000, 30000);
      this.minInterval = this.number('minInterval', 1000, 500, 20000);
      this.activeJob = null;
      this.nextChangeAt = 0;
      this.variation = this.number('variation', 0, 0, 4000);
      this.transition = this.number('transition', 320, 0, 1000);
      this.desktopCount = this.number('desktopCount', 16, 8, 16);
      this.tileWidth = this.number('tileWidth', 220, 180, 320);
      this.gap = this.number('gap', 16, 0, 40);
      this.toggle = this.querySelector('[data-mjl-toggle]');
      for (const tile of [...this.grid.children]) this.attachTile(tile);

      this.toggle?.addEventListener('click', () => {
        if (this.wantsToRun()) {
          this.userPaused = true;
        } else {
          this.userPaused = false;
          this.explicitPlay = true;
        }
        this.sync();
      }, {signal});
      window.addEventListener('resize', () => this.resize(), {signal, passive: true});
      document.addEventListener('visibilitychange', () => this.sync(), {signal});
      this.motion.addEventListener('change', () => { this.explicitPlay = false; this.sync(); }, {signal});
      window.addEventListener('pointerup', () => this.releasePointers(), {signal});
      window.addEventListener('pointercancel', () => this.releasePointers(), {signal});
      if (this.editor) {
        document.addEventListener('shopify:block:select', event => {
          const items = this.pool.filter(item => item.block === event.detail?.blockId);
          if (!items.length) return;
          this.editorSelected = true;
          this.sync();
          this.reveal(items);
        }, {signal});
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.pool.some(item => item.block === event.detail?.blockId)) return;
          this.editorSelected = false;
          this.sync();
        }, {signal});
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.sync();
        }, {threshold: 0});
        this.observer.observe(this);
      }
      if ('ResizeObserver' in window) {
        this.sizeObserver = new ResizeObserver(() => this.resize());
        this.sizeObserver.observe(this.grid);
      }
      this.resize();
      this.seen = new Set(this.states.map(state => state.id));
    }

    number(key, fallback, min, max) {
      const value = Number(this.dataset[key]);
      return Math.max(min, Math.min(max, Number.isFinite(value) ? value : fallback));
    }

    visibleCount() {
      if (window.innerWidth < 768) return Math.min(6, this.pool.length);
      const available = this.grid.clientWidth || Math.max(1, window.innerWidth - 48);
      const capacity = Math.max(1, Math.floor((available + this.gap) / (this.tileWidth + this.gap)));
      return Math.min(capacity, this.desktopCount, this.pool.length);
    }

    resize() {
      if (!this.lifecycle) return;
      const count = this.visibleCount();
      if (this.states.length !== count) this.stopAll();
      while (this.states.length > count) {
        // Keep a keyboard-focused product in the grid when the window gets narrower.
        let index = this.states.length - 1;
        if (this.states[index].tile.contains(document.activeElement)) index -= 1;
        const [state] = this.states.splice(Math.max(0, index), 1);
        this.cancel(state);
        state.tile.remove();
      }
      while (this.states.length < count) {
        const item = this.candidate();
        if (!item) break;
        const tile = document.createElement('li');
        tile.className = 'mjl-rg__tile';
        tile.append(this.linkFor(item));
        this.grid.append(tile);
        this.attachTile(tile);
      }
      this.dataset.layoutReady = 'true';
      this.grid.style.gridTemplateColumns = window.innerWidth < 768
        ? 'repeat(3, minmax(0, 1fr))'
        : `repeat(${Math.max(1, count)}, minmax(0, ${this.tileWidth * 1.5}px))`;
      this.sync();
    }

    attachTile(tile) {
      const id = tile.querySelector('[data-slot-id]')?.dataset.slotId;
      if (!this.byId.has(id)) { tile.remove(); return; }
      const state = {tile, id, timer: null, job: null, hover: false, focus: false, pressed: false};
      this.states.push(state);
      this.seen.add(id);
      const signal = this.lifecycle.signal;
      const lock = () => this.cancel(state);
      const unlock = () => { if (!this.locked(state)) this.arm(state); };
      tile.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch') return;
        state.hover = true; lock();
      }, {signal});
      tile.addEventListener('pointerleave', () => { state.hover = false; unlock(); }, {signal});
      tile.addEventListener('focusin', () => { state.focus = true; lock(); }, {signal});
      tile.addEventListener('focusout', event => {
        if (tile.contains(event.relatedTarget)) return;
        state.focus = false; unlock();
      }, {signal});
      tile.addEventListener('pointerdown', () => { state.pressed = true; lock(); }, {signal});
    }

    releasePointers() {
      for (const state of this.states) {
        if (!state.pressed) continue;
        state.pressed = false;
        if (!this.locked(state)) this.arm(state);
      }
    }

    locked(state) { return state.hover || state.focus || state.pressed; }

    wantsToRun() {
      return !this.userPaused && !this.editorSelected &&
        (this.explicitPlay || (this.auto && !this.motion.matches && !this.editor));
    }

    sync() {
      if (!this.lifecycle) return;
      const canRotate = this.pool.length > this.states.length;
      const intent = this.wantsToRun();
      if (this.toggle) {
        this.toggle.hidden = !canRotate || (!this.auto && !this.editor);
        this.toggle.textContent = intent ? 'Pause product rotation' : 'Play product rotation';
        this.toggle.setAttribute('aria-pressed', String(intent));
      }
      const shouldRun = canRotate && intent && this.inView && !document.hidden;
      if (!shouldRun) { this.stopAll(); return; }
      if (this.running) return;
      this.running = true;
      // Randomize the waiting order; one shared gate admits only one transition.
      this.shuffled(this.states).forEach(state => this.arm(state));
    }

    stopAll() {
      this.running = false;
      for (const state of this.states || []) this.cancel(state);
    }

    cancel(state) {
      clearTimeout(state.timer);
      state.timer = null;
      state.job?.abort();
      state.job = null;
      state.tile.classList.remove('mjl-rg__tile--fading');
    }

    arm(state, extraDelay = 0) {
      clearTimeout(state.timer);
      state.timer = null;
      if (!this.running || this.locked(state) || state.job || !this.states.includes(state)) return;
      const variation = (Math.random() * 2 - 1) * this.variation;
      const delay = Math.max(2000, this.dwell + variation) + extraDelay;
      state.timer = setTimeout(() => { state.timer = null; this.swap(state); }, delay);
    }

    shuffled(items) {
      const result = [...items];
      for (let index = result.length - 1; index > 0; index -= 1) {
        const other = Math.floor(Math.random() * (index + 1));
        [result[index], result[other]] = [result[other], result[index]];
      }
      return result;
    }

    candidate() {
      const occupied = new Set(this.states.map(state => state.id));
      const available = this.pool.filter(item => !occupied.has(item.id) && !this.reserved.has(item.id) && (this.failed.get(item.id) || 0) <= Date.now());
      if (!available.length) return null;
      let unseen = available.filter(item => !this.seen.has(item.id));
      if (!unseen.length) {
        // All off-screen choices have been seen; begin the next shuffled round.
        this.seen = new Set(occupied);
        unseen = available;
      }
      return unseen[Math.floor(Math.random() * unseen.length)];
    }

    linkFor(item) {
      // Import into the live document so a detached incoming image can load and decode.
      const link = document.importNode(item.template.content.querySelector('a'), true);
      const img = link.querySelector('img');
      if (img) { img.loading = 'eager'; img.fetchPriority = 'auto'; }
      return link;
    }

    wait(ms, signal) {
      return new Promise(resolve => {
        if (signal.aborted) { resolve(false); return; }
        const finish = result => {
          clearTimeout(timer);
          signal.removeEventListener('abort', abort);
          resolve(result);
        };
        const abort = () => finish(false);
        const timer = setTimeout(() => finish(true), ms);
        signal.addEventListener('abort', abort, {once: true});
      });
    }

    ready(img, signal) {
      if (!img || signal.aborted) return Promise.resolve(false);
      if (img.complete && img.naturalWidth > 0) return Promise.resolve(true);
      return new Promise(resolve => {
        let done = false;
        const finish = ok => {
          if (done) return;
          done = true;
          clearTimeout(timeout);
          img.removeEventListener('load', loaded);
          img.removeEventListener('error', failed);
          signal.removeEventListener('abort', failed);
          resolve(ok);
        };
        const loaded = () => finish(img.naturalWidth > 0);
        const failed = () => finish(false);
        const timeout = setTimeout(failed, 10000);
        img.addEventListener('load', loaded, {once: true});
        img.addEventListener('error', failed, {once: true});
        signal.addEventListener('abort', failed, {once: true});
        if (img.decode) img.decode().then(loaded).catch(failed);
      });
    }

    async swap(state) {
      if (!this.running || this.locked(state) || state.job) return;
      if (this.activeJob || Date.now() < this.nextChangeAt) {
        clearTimeout(state.timer);
        const retry = Math.max(50, this.nextChangeAt - Date.now(), this.activeJob ? 250 : 0);
        state.timer = setTimeout(() => { state.timer = null; this.swap(state); }, retry);
        return;
      }
      const item = this.candidate();
      if (!item) { this.arm(state); return; }
      const job = new AbortController();
      const signal = job.signal;
      state.job = job;
      this.activeJob = job;
      this.reserved.add(item.id);
      try {
        const link = this.linkFor(item);
        const loaded = await this.ready(link.querySelector('img'), signal);
        if (!loaded) {
          if (!signal.aborted) this.failed.set(item.id, Date.now() + 60000);
          return;
        }
        if (signal.aborted || !this.running || this.locked(state) || !this.states.includes(state)) return;
        const half = this.motion.matches ? 0 : this.transition / 2;
        // Measure the minimum interval between transition starts. The shared job
        // also stays locked through loading and the complete fade-in.
        this.nextChangeAt = Date.now() + Math.max(this.minInterval, half * 2);
        if (half) {
          state.tile.classList.add('mjl-rg__tile--fading');
          if (!await this.wait(half, signal)) return;
        }
        if (signal.aborted || !this.running || this.locked(state)) return;
        // Change the entire anchor atomically: its photo, label and URL always belong together.
        state.tile.replaceChildren(link);
        state.id = item.id;
        this.seen.add(item.id);
        state.tile.classList.remove('mjl-rg__tile--fading');
        if (half) await this.wait(half, signal);
      } catch (_) {
        if (!signal.aborted) this.failed.set(item.id, Date.now() + 60000);
      } finally {
        if (this.activeJob === job) this.activeJob = null;
        this.reserved.delete(item.id);
        // A cancelled job must not reset a newer job after resize or editor reload.
        if (state.job === job) {
          state.job = null;
          state.tile.classList.remove('mjl-rg__tile--fading');
          this.arm(state);
        }
      }
    }

    reveal(items) {
      const requested = new Set(items.map(item => item.id));
      for (const item of items) {
        if (this.states.some(state => state.id === item.id)) continue;
        const state = this.states.find(candidate => !requested.has(candidate.id) && !candidate.tile.contains(document.activeElement));
        if (!state) continue;
        state.tile.replaceChildren(this.linkFor(item));
        state.id = item.id;
        this.seen.add(item.id);
      }
    }
  }
  customElements.define('mjl-product-hero', MJLProductHero);
})();


  } catch(e) { console.error(e); }
})();
})();
